import { JustValidate } from 'just-validate';
import SimpleLightbox from 'simplelightbox';
import Slider from './scripts/components/slider';
import Accordion from './scripts/components/accordion';

document.addEventListener('DOMContentLoaded', () => {
    window.slider = new Slider('.slider');
});

document.addEventListener('DOMContentLoaded', () => {
  
  let path = `${window.location.origin}/wp-content/themes/dreamclass2/dist/img/animation/`;
  
  const app = document.querySelector('.app');
  const data = JSON.parse(document.querySelector('#feature-list').innerHTML);
  const content = app.querySelector('.app-content');
  const appButtons = document.querySelectorAll('.app-buttons li input');
  
  let pointer;
  let timer = 0;
  const duration = 450;

  console.log(data.items.find((item) => {
    return item.id="classes"
  }));

  const fetchImage = (button) => {
      const image = button.dataset.file;
      const current = data.items.find(item => item.id === image);
      const className = current.class;
      const title = current.title;
      const list = current.items;
      document.querySelector('.app-description').innerHTML = '';
      let ul = `<ul class="checkboxes">`;
      list.forEach((item) => {
        ul += `<li>${item}</li>` ;
      });
      ul += `</ul>`;
      app.classList.remove('loaded');
      app.classList.add('loading');
      content.innerHTML = '';

      const img = new Image();
      img.src = `${path}${image}.png`;
      img.onload = () => {
        document.querySelector('.app-title').innerText = title;
        document.querySelector('.app-title').classList.forEach((cl) => {
          if(cl !== 'app-title'){
            document.querySelector('.app-title').classList.remove(cl);
          }
        });
        document.querySelector('.app-title').classList.add(className);
        console.log(ul);
        document.querySelector('.app-description').insertAdjacentHTML('beforeend', ul);
        app.classList.remove('loading');
        setTimeout(() => {
            content.appendChild(img);
            app.classList.add('loaded');
        }, 80);
      };
      /* fetch(`${path}${image}.png`).then((res) => {
          return res.text()
      }).then((data) => {
        console.log(data);
          content.innerHTML = data;
          //main.style.backgroundColor = color;
          document.querySelector('.app-title').innerText = title;
          document.querySelector('.app-title').classList.add(className);
          document.querySelector('.app-description').innerText = description;
          app.classList.remove('loading');
          setTimeout(() => {
              app.classList.add('loaded');
          }, 80)
      }); */
  }

  appButtons.forEach((item, i) => {
      if (item.checked) {
          fetchImage(item);
      }
      item.addEventListener('click', (e) => {
          fetchImage(e.target);
          timer = 0;
      })
  });
  
  function animate() {
      timer++;
      if (timer == duration) {
          appButtons.forEach((item, i) => {
              if (item.checked) {
                  pointer = i;
              }
          })

          const next = (pointer == appButtons.length - 1) ? 0 : pointer + 1;
          
          appButtons[next].checked = true;
          fetchImage(appButtons[next]);
          timer = 0;
      }
      //window.requestAnimationFrame(animate);
  }   
  
  animate();
});

document.addEventListener('DOMContentLoaded', () => {

  let lightbox = new SimpleLightbox('figure.wp-block-image a');


  const passButton = document.querySelector('.r-button--password');
  const passField = document.querySelector('#password');
  if (passButton) {
    passButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (passField.getAttribute('type') === 'password') {
        passField.setAttribute('type', 'text');
      } else {
        passField.setAttribute('type', 'password');
      }
    })
  }

  // initialize the validation library
  if (document.getElementById('#registrationForm')) {

    const validation = new JustValidate('#registrationForm', {
      errorFieldCssClass: 'is-invalid',
      validateBeforeSubmitting: true,
    });
    // apply rules to form fields
  
    validation
      .addField('#organization-name', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
      ])
      .addField('#domain-name', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        }
      ])
      .addField('#email', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
        {
          rule: 'email',
          errorMessage: 'Email is invalid!',
        }
      ])
      .addField('#your-name', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
      ])
      .addField('#phone-number', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
      ])
      .addField('#password', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
      ])
      .addField('#accept', [
        {
          rule: 'required',
          errorMessage: 'Field is required',
        },
      ]);
  
  
      const domainField = document.getElementById('domain-name');
      const emailField = document.getElementById('email');
      const fields = [domainField, emailField];
  
      
    function existingUserError() {
      
      fields.forEach((field) => {
        if (!field.parentNode.querySelector('.existing-user-label')) {
          const response = document.createElement('div');
          
          response.style.color = 'rgb(184, 17, 17)';
          response.className = 'existing-user-label';
          response.innerText = 'Domain name or email already exists';
          field.classList.add('is-invalid');
          field.parentNode.append(response);  
        }
      });
      
    }
    
    function existingUserUpdate() {
      
      fields.forEach((field) => {
        field.classList.remove('is-invalid');
        field.parentNode.querySelector('.existing-user-label').remove();  
      });
      
    }
    
    domainField.addEventListener('keydown', () => {
      existingUserUpdate();
    });
  
    emailField.addEventListener('keydown', () => {
      existingUserUpdate();
    });
  
    function registerUser() {
      jQuery.ajax('https://api.dreamclass.io/account', {
        contentType: 'application/json; charset=utf-8',
        dataType: "json",
        data: JSON.stringify({
          domain: jQuery('#domain-name').val(),
          organization: jQuery('#organization-name').val(),
          name: jQuery('#your-name').val(),
          phoneNumber: jQuery('#phone-number').val(),
          email: jQuery('#email').val(),
          password: jQuery('#password').val(),
          timezone: window.Intl.DateTimeFormat().resolvedOptions().timeZone
        }),
        type: 'POST',
        success: (accountInfo) => {
          window.dataLayer = window.dataLayer || [];
  
          dataLayer.push({ 
            userId: accountInfo.account.id,
            event: 'accountcreate',
          });
  
          window.location.href = `https://${accountInfo.account.domain}.dreamclass.io/pages/auth/register-success?token=${accountInfo['token']['access_token']}&id=${accountInfo.account.id}`;
        },
        error: () => {
          alert('Some error message');
        }
      });
      }
  
      validation.onSuccess(event => {
        event.preventDefault();
  
        jQuery.ajax('https://api.dreamclass.io/account/searchaccount', {
          contentType: 'application/json',
          dataType: "json",
          data: {
            domain: jQuery('#domain-name').val(),
            email: jQuery('#email').val()
          },
          type: 'GET',
          success: (res) => {
            if (res.status === 200) {
              registerUser();
            } else {
              existingUserError();
            }
          },
          error: (res) => {
            if (res.status === 200) {
              registerUser();
            } else {
              existingUserError();
            }
          }
        });
      });
  }



    jQuery('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = jQuery(this.hash);
        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          jQuery('html, body').animate({
            scrollTop: target.offset().top - 60
          }, 600, function() {
            // Callback after animation
            // Must change focus!
            var $target = jQuery(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });

    const landingAccordions = document.querySelectorAll('.is-style-accordion');
    class LAccordion extends Accordion{
      slideDown(item) {
        item.querySelector('ul').style.maxHeight = `${item.querySelector('ul').scrollHeight}px`;
        item.classList.add('active');
        setTimeout(() => {
            item.querySelector('ul').style.maxHeight = `none`;
        }, 500);
      }

      slideUp(item) {
        item.classList.remove('active');
        item.querySelector('ul').style.maxHeight = `${item.querySelector('ul').scrollHeight}px`;
        setTimeout(() => {
            item.querySelector('ul').style.maxHeight = 0;
            item.classList.remove('active');
            this.toggler.checked = false;
        }, 1);
      }
    }
    if ( landingAccordions.length > 0 ) {
        new LAccordion('.is-style-accordion > li');
    }

});